module.exports = __webpack_public_path__ + "static/media/flask-potion.217744a4.svg";